module.exports = __webpack_public_path__ + "img/img_qr_fail.f2247984.png";